import { PageController } from '@client/components/_core/layout/PageController';
import { FieldConfigurationList } from '@client/components/field-configurations/FieldConfigurationList';
import { createFileRoute } from '@tanstack/react-router';
import { SlidersHorizontal } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/training/custom-fields')({
    staticData: {
        metadata: {
            title: 'Custom fields',
        },
        ui: {
            icon: SlidersHorizontal,
            title: 'Training custom fields',
            subtitle: 'Define additional fields captured against training records',
            menuDescription: 'Define additional fields captured against training records',
        },
    },
    component: TrainingCustomFields,
});

function TrainingCustomFields() {
    return (
        <PageController route={Route}>
            <FieldConfigurationList entity="TRAINING" showEntityConfiguration />
        </PageController>
    );
}
